export const RequiredStar = () => {
    return (
        <>
            <sup className="text-danger">*</sup>
        </>
    )
}